/**
 * Spacing refers to the key in the Chakra default spacing object map - see https://chakra-ui.com/docs/styled-system/theme#spacing
 * @param px: "1px"
   @param _0_5: "0.125rem"
   @param _1: "0.25rem"
   @param _1_5: "0.375rem"
   @param _2: "0.5rem"
   @param _2_5: "0.625rem"
   @param _3: "0.75rem"
   @param _3_5: "0.875rem"
   @param _4: "1rem"
   @param _5: "1.25rem"
   @param _6: "1.5rem"
   @param _7: "1.75rem"
   @param _8: "2rem"
   @param _9: "2.25rem"
   @param _10: "2.5rem"
   @param _12: "3rem"
   @param _14: "3.5rem"
   @param _16: "4rem"
   @param _20: "5rem"
   @param _24: "6rem"
   @param _28: "7rem"
   @param _32: "8rem"
   @param _36: "9rem"
   @param _40: "10rem"
   @param _44: "11rem"
   @param _48: "12rem"
   @param _52: "13rem"
   @param _56: "14rem"
   @param _60: "15rem"
   @param _64: "16rem"
   @param _72: "18rem"
   @param _80: "20rem"
   @param _96: "24rem"
 */
export enum Spacing {
  px = 'px', //"1px"
  _0_5 = '0.5',
  _1 = '1',
  _1_5 = '1.5',
  _2 = '2',
  _2_5 = '2.5',
  _3 = '3',
  _3_5 = '3.5',
  _4 = '4',
  _5 = '5',
  _6 = '6',
  _7 = '7',
  _8 = '8',
  _9 = '9',
  _10 = '10',
  _12 = '12',
  _14 = '14',
  _16 = '16',
  _20 = '20',
  _24 = '24',
  _28 = '28',
  _32 = '32',
  _36 = '36',
  _40 = '40',
  _44 = '44',
  _48 = '48',
  _52 = '52',
  _56 = '56',
  _60 = '60',
  _64 = '64',
  _72 = '72',
  _80 = '80',
  _96 = '96',
}

/**
 * Breakpoints refers to the key in the Chakra default spacing object map - see https://chakra-ui.com/docs/styled-system/theme#breakpoints
 */
export enum Breakpoint {
  base = 'base',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
  xxl = '2xl',
}

/**
  @param full: '100%'
  @param max: 'max-content'
  @param min: 'min-content'
  @param _3xs: '14rem'
  @param _2xs: '16rem'
  @param xs: '20rem'
  @param sm: '24rem'
  @param md: '28rem'
  @param lg: '32rem'
  @param xl: '36rem'
  @param _2xl: '42rem'
  @param _3xl: '48rem'
  @param _4xl: '56rem'
  @param _5xl: '64rem'
  @param _6xl: '72rem'
  @param _7xl: '80rem'
  @param _8xl: '90rem'

 @description Size refers to the key in the Chakra default size object map.
 @description See: https://chakra-ui.com/docs/styled-system/theme#sizes
*/
export enum Size {
  full = 'full',
  max = 'max',
  min = 'min',
  _3xs = '3xs',
  _2xs = '2xs',
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
  _2xl = '2xl',
  _3xl = '3xl',
  _4xl = '4xl',
  _5xl = '5xl',
  _6xl = '6xl',
  _7xl = '7xl',
  _8xl = '8xl',
}

/**
 * @description Radii refers to the key in the Chakra default spacing object map.
 * @description See: https://chakra-ui.com/docs/styled-system/theme#border-radius
 */
export enum Radii {
  none = 'none',
  sm = 'sm',
  base = 'base',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
  _2xl = '2xl',
  _3xl = '3xl',
  full = 'full',
}

/**
 * zIndex refers to the key in the Chakra default spacing object map - see https://chakra-ui.com/docs/styled-system/theme#z-index-values
 */
export enum ZIndex {
  hide = 'hide',
  auto = 'auto',
  base = 'base',
  docked = 'docked',
  dropdown = 'dropdown',
  sticky = 'sticky',
  banner = 'banner',
  overlay = 'overlay',
  modal = 'modal',
  popover = 'popover',
  skipLink = 'skipLink',
  toast = 'toast',
  tooltip = 'tooltip',
}
